import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const supplierSpecialOffersDetailProductsState = (state: AppState) =>
    state.contentManagement.supplierSpecialOffers.detail.products;

export const supplierSpecialOffersDetailProductsSelector = createSelector(
    supplierSpecialOffersDetailProductsState,
    state => state.products
);
